// extracted by mini-css-extract-plugin
module.exports = {"slider":"Selector_slider__1jgnX","values":"Selector_values__2ArRZ"};